import _find from 'lodash/find';

import {
    SUGGESTION_TYPES,
    PLAYERS_KEY,
    TEAMS_KEY,
    TAGS_KEY,
} from './typeaheadConstants';

const PLAYER_ID_KEY = 'playerId';
const TEAM_ID_KEY = 'teamId';
const TAG_ID_KEY = 'slug';

const mapPlayerInfo = (playerInfo) => {

    const {
        displayName: fullName,
        [PLAYER_ID_KEY]: id,
        teamId,
        active,
        teamTriCode: teamAbbreviation,
        headshots,
    } = playerInfo;

    return {
        type: SUGGESTION_TYPES.players,
        id,
        name: fullName,
        teamId,
        isActivePlayer: active,
        teamAbbreviation,
        image: headshots[0].url,
        imageFallback: `https://content.mlb.com/images/headshots/current/60x60/generic.png`,
        value: String(id),
        displayName: fullName,
    };

};

const mapTeamInfo = (teamInfo) => {

    const {
        [TEAM_ID_KEY]: id,
        name,
        displayName,
        logos,
    } = teamInfo;

    const image = _find(logos, { type: 'ON_DARK' }).url;

    return {
        type: SUGGESTION_TYPES.teams,
        id,
        name,
        displayName,
        image,
        value: String(id),
    };

};

const mapTagInfo = (tagInfo) => {

    const {
        name,
        [TAG_ID_KEY]: value,
    } = tagInfo;

    return {
        type: SUGGESTION_TYPES.tags,
        name,
        value,
    };

};

const defaultSuggestions = {
    [PLAYERS_KEY]: [],
    [TEAMS_KEY]: [],
    [TAGS_KEY]: [],
};

const idMap = {
    [PLAYERS_KEY]: PLAYER_ID_KEY,
    [TEAMS_KEY]: TEAM_ID_KEY,
    [TAGS_KEY]: TAG_ID_KEY,
};

const processSuggestions = ({
    suggestions = defaultSuggestions,
    suggestionKeys = [
        PLAYERS_KEY,
        TEAMS_KEY,
        TAGS_KEY,
    ],
    displayCount = 6,
    excludeSuggestions = [],
}) => {
    
    excludeSuggestions.forEach((excludeSuggestion) => {

        const {
            suggestionsKey,
            ids,
        } = excludeSuggestion;

        suggestions[suggestionsKey] = suggestions[suggestionsKey].filter(suggestion => !ids.includes(suggestion[idMap[suggestionsKey]]?.toString()));

    });
    
    const players = suggestionKeys.includes(PLAYERS_KEY)
        ? suggestions[PLAYERS_KEY].map(suggestion => {

            return mapPlayerInfo(suggestion);

        })
        : [];

    const teams = suggestionKeys.includes(TEAMS_KEY)
        ? suggestions[TEAMS_KEY].map(suggestion => {

            return mapTeamInfo(suggestion);

        })
        : [];

    const tags = suggestionKeys.includes(TAGS_KEY)
        ? suggestions[TAGS_KEY].map(suggestion => {

            return mapTagInfo(suggestion);

        })
        : [];

    return [
        ...teams,
        ...players,
        ...tags,
    ].slice(0, displayCount);

};

export default processSuggestions;